import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-header-hifpt',
  templateUrl: './header-hifpt.component.html',
  styleUrls: ['./header-hifpt.component.scss'],
})
export class HeaderHifptComponent {
  constructor() {}
  goToPage(str: string) {
    if (str === 'shop-fpt') {
      if (
        window.location.origin.includes('staging') ||
        window.location.origin.includes('localhost')
      ) {
        window.location.href =
          'https://shop-stag.fpt.vn/tin-tuc/trai-nghiem-wifi6';
      } else {
        window.location.href = 'https://shop.fpt.vn/tin-tuc/trai-nghiem-wifi6';
      }
    }
  }
}
